import { cn, Radio, RadioGroup, RadioGroupProps } from '@heroui/react'
import { Field, FieldProps } from 'formik'

interface RadioOption {
  value: string
  label: string
}

export interface RadioGroupFormikProps extends Omit<RadioGroupProps, 'value' | 'onValueChange'> {
  name: string
  options: RadioOption[]
  label?: string
  classNameContainer?: string
  classNames?: {
    label?: string
    base?: string
    control?: string
    [key: string]: string | undefined
  }
}

const RadioGroupFormik = ({
  name,
  options,
  label,
  classNameContainer,
  classNames,
  ...props
}: RadioGroupFormikProps) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <RadioGroup
          className={cn('custom-radio')}
          label={label}
          value={field.value}
          onValueChange={(value: string) => form.setFieldValue(name, value)}
          {...props}
        >
          <div className={cn('flex flex-col gap-4', classNameContainer)}>
            {options.map((option: RadioOption) => (
              <Radio
                key={option.value}
                size="sm"
                value={option.value}
                classNames={{
                  label: 'text-[#1F242E]',
                  base: 'flex gap-3 items-center',
                  control: 'bg-[#fff] data-[selected=true]:bg-[#222]',
                  ...classNames,
                }}
              >
                {option.label}
              </Radio>
            ))}
          </div>
        </RadioGroup>
      )}
    </Field>
  )
}

export default RadioGroupFormik
